export type InstantConfigValue = boolean | string | string[] | number | number[] | object;
export const negativePrefix = 'non-';
export const cacheSuffix = '-cached';
export const samplingSeparator = '/';
export const worldWide = 'XX';
// precision to 0.00000001 (or 0.000001%) of traffic
export const precision = 10 ** 6;
